export default "__VITE_ASSET__DTIVMwky__"